import React from "react";
import {observer} from "mobx-react";
import {StringFieldEditorComponent} from "../../../../components/forms/string-field/string-field-editor.component";
import {FormComponent} from "../../../../components/forms/form.component";
import {GenderFieldEditorComponent} from "../../../../components/forms/gender/gender-field-editor.component";
import {useServices} from "../../../../hooks/use-services.hook";
import { CountryPickerComponent } from "../../../../components/country-picker/country-picker.component";
import {IUserProfileEditorViewModel} from "../../../../services/user/models/profile/user-profile-editor-view-model.interface";
import {FieldsSectionComponent} from "../../../../components/forms-view/fields-section.component";
import {
    DateFieldEditorWithInputMaskComponent
} from "../../../../components/forms/date-time/date-field-editor-with-input-mask.component";


interface B2CUserContactInformationEditorComponentProps {
    userProfileEditor: IUserProfileEditorViewModel;
}

export const B2CUserContactInformationEditorComponent: React.FC<B2CUserContactInformationEditorComponentProps> = observer((props) => {
    const services = useServices();
    const time = services.time;
    const maxBirthDate = time.addYears(time.makeShortDate(time.currentDate), -18);
    const fields = props.userProfileEditor.fields;

    return (
        <FormComponent title={props.userProfileEditor.getFullName()}>

            <FieldsSectionComponent title={services.language.translate(`Personal details`)}>
                <DateFieldEditorWithInputMaskComponent field={fields.dateOfBirth} maxDate={maxBirthDate}/>
                <GenderFieldEditorComponent field={fields.gender} useGenderAsNumber={true}/>
                <CountryPickerComponent key={fields.nationality.value}
                                        field={fields.nationality}
                                        popupHeaderTitle={services.language.translate('Search citizenship')}/>
            </FieldsSectionComponent>

            <FieldsSectionComponent title={services.language.translate(`Contact details`)}>
                <StringFieldEditorComponent field={fields.phoneNumber} />
            </FieldsSectionComponent>


        </FormComponent>
    )
});
